import { render, staticRenderFns } from "./MerchantView.vue?vue&type=template&id=610688c2&scoped=true&"
import script from "./MerchantView.vue?vue&type=script&lang=js&"
export * from "./MerchantView.vue?vue&type=script&lang=js&"
import style0 from "./MerchantView.vue?vue&type=style&index=0&id=610688c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610688c2",
  null
  
)

export default component.exports